import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade — GPS Drive" },
      {
        name: "description",
        content: "Política de Privacidade da plataforma, aplicativo e serviços GPS Drive.",
      },
    ],
  }),
  component: PrivacyPolicyPage,
});

const SECTIONS: { title: string; body: React.ReactNode }[] = [
  {
    title: "1. Dados que podemos coletar",
    body: (
      <>
        <p>Dependendo da utilização da plataforma, podemos coletar diferentes tipos de informações, incluindo:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Nome;</li>
          <li>E-mail;</li>
          <li>Número de telefone;</li>
          <li>Dados de acesso à conta;</li>
          <li>Informações relacionadas à empresa;</li>
          <li>Informações de veículos;</li>
          <li>Identificação dos dispositivos de rastreamento;</li>
          <li>Dados de localização dos veículos;</li>
          <li>Histórico de trajetos;</li>
          <li>Velocidade;</li>
          <li>Direção;</li>
          <li>Quilometragem;</li>
          <li>Paradas;</li>
          <li>Eventos e alertas;</li>
          <li>Informações técnicas relacionadas ao dispositivo e à utilização do sistema.</li>
        </ul>
      </>
    ),
  },
  {
    title: "2. Como utilizamos os dados",
    body: (
      <>
        <p>Os dados coletados podem ser utilizados para:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Criar e administrar contas;</li>
          <li>Permitir o acesso à plataforma;</li>
          <li>Autenticar usuários;</li>
          <li>Disponibilizar o monitoramento dos veículos;</li>
          <li>Exibir localização em tempo real;</li>
          <li>Apresentar históricos e trajetos;</li>
          <li>Gerar alertas e notificações;</li>
          <li>Gerar relatórios;</li>
          <li>Gerenciar veículos;</li>
          <li>Gerenciar usuários e permissões;</li>
          <li>Disponibilizar funcionalidades de gestão de frota;</li>
          <li>Melhorar o funcionamento e a segurança da plataforma;</li>
          <li>Prestar suporte aos usuários;</li>
          <li>Identificar e prevenir acessos não autorizados;</li>
          <li>Cumprir obrigações legais;</li>
          <li>Exercer direitos previstos em lei.</li>
        </ul>
      </>
    ),
  },
  {
    title: "3. Dados de localização",
    body: (
      <>
        <p>A GPS Drive oferece serviços de monitoramento e rastreamento veicular.</p>
        <p>
          Para disponibilizar essas funcionalidades, a plataforma poderá receber e armazenar informações
          transmitidas pelos dispositivos de rastreamento vinculados aos veículos.
        </p>
        <p>
          Essas informações podem incluir localização, data, horário, velocidade, direção, quilometragem,
          paradas, eventos e histórico de trajetos.
        </p>
        <p>
          O acesso aos dados de localização é controlado de acordo com os usuários, empresas e permissões
          configuradas na plataforma.
        </p>
      </>
    ),
  },
  {
    title: "4. Usuários e permissões",
    body: (
      <>
        <p>
          A GPS Drive permite que empresas criem usuários e definam diferentes níveis de acesso às
          funcionalidades da plataforma.
        </p>
        <p>
          As informações disponíveis para cada usuário podem variar de acordo com as permissões atribuídas
          pelo administrador da conta.
        </p>
        <p>Cada usuário é responsável por manter suas credenciais de acesso em segurança e não compartilhá-las com terceiros.</p>
      </>
    ),
  },
  {
    title: "5. Compartilhamento de dados",
    body: (
      <>
        <p>
          Os dados poderão ser compartilhados quando necessário para o funcionamento dos serviços,
          cumprimento de obrigações legais ou execução de atividades relacionadas à plataforma.
        </p>
        <p>
          Isso poderá incluir prestadores de serviços tecnológicos, infraestrutura, armazenamento,
          comunicação, notificações, pagamentos e outros serviços necessários para o funcionamento da GPS
          Drive.
        </p>
        <p>A GPS Drive não comercializa dados pessoais de seus usuários.</p>
      </>
    ),
  },
  {
    title: "6. Segurança dos dados",
    body: (
      <>
        <p>
          A GPS Drive adota medidas técnicas e administrativas destinadas a proteger os dados contra acessos
          não autorizados, perda, alteração, divulgação ou utilização indevida.
        </p>
        <p>
          Entre essas medidas podem estar mecanismos de autenticação, controle de acesso, gerenciamento de
          permissões, monitoramento, backups e outras medidas de segurança aplicáveis à plataforma.
        </p>
        <p>Apesar dos esforços empregados, nenhum sistema conectado à internet pode garantir segurança absoluta.</p>
      </>
    ),
  },
  {
    title: "7. Cookies e tecnologias semelhantes",
    body: (
      <p>
        O site e a plataforma GPS Drive poderão utilizar cookies e tecnologias semelhantes para manter
        sessões, armazenar preferências, melhorar a experiência do usuário, garantir o funcionamento dos
        serviços e, quando aplicável, obter informações estatísticas sobre a utilização da plataforma.
      </p>
    ),
  },
  {
    title: "8. Aplicativo GPS Drive",
    body: (
      <>
        <p>O aplicativo poderá solicitar determinadas permissões do dispositivo para disponibilizar funcionalidades específicas.</p>
        <p>Dependendo dos recursos utilizados, essas permissões poderão estar relacionadas a:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Notificações;</li>
          <li>Localização;</li>
          <li>Internet;</li>
          <li>Recursos necessários ao funcionamento do aplicativo.</li>
        </ul>
        <p>As permissões utilizadas poderão variar de acordo com a versão do aplicativo e suas funcionalidades.</p>
      </>
    ),
  },
  {
    title: "9. Armazenamento e retenção",
    body: (
      <>
        <p>
          Os dados poderão ser mantidos pelo período necessário para fornecer os serviços, cumprir
          obrigações legais, atender às finalidades descritas nesta Política e proteger os direitos da GPS
          Drive e de seus usuários.
        </p>
        <p>
          Quando não houver mais necessidade de manutenção dos dados, eles poderão ser excluídos,
          anonimizados ou mantidos quando houver fundamento legal para sua conservação.
        </p>
      </>
    ),
  },
  {
    title: "10. Direitos dos usuários",
    body: (
      <>
        <p>Nos termos da legislação aplicável, os titulares de dados pessoais poderão exercer seus direitos, incluindo:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Confirmar a existência de tratamento de seus dados;</li>
          <li>Solicitar acesso aos dados;</li>
          <li>Solicitar correção de dados incorretos ou desatualizados;</li>
          <li>Solicitar informações sobre o tratamento e compartilhamento de seus dados;</li>
          <li>Solicitar a eliminação ou anonimização dos dados quando aplicável;</li>
          <li>Solicitar a portabilidade quando aplicável;</li>
          <li>Revogar o consentimento quando essa for a base legal utilizada;</li>
          <li>Exercer os demais direitos previstos na legislação aplicável.</li>
        </ul>
      </>
    ),
  },
  {
    title: "11. Proteção das credenciais",
    body: (
      <>
        <p>Os usuários devem manter suas senhas e demais credenciais de acesso em sigilo.</p>
        <p>
          A GPS Drive não se responsabiliza por acessos realizados mediante credenciais compartilhadas
          voluntariamente pelo usuário ou comprometidas por falta de cuidado com as informações de acesso.
        </p>
      </>
    ),
  },
  {
    title: "12. Dados de menores",
    body: (
      <>
        <p>A GPS Drive é destinada principalmente a empresas, gestores de frotas e usuários autorizados.</p>
        <p>Não buscamos coletar intencionalmente dados pessoais de crianças sem a adoção das medidas e bases legais aplicáveis.</p>
      </>
    ),
  },
  {
    title: "13. Alterações nesta Política",
    body: (
      <>
        <p>
          Esta Política de Privacidade poderá ser atualizada sempre que necessário para refletir alterações
          nos serviços, funcionalidades, tecnologias utilizadas ou requisitos legais.
        </p>
        <p>A versão mais recente estará sempre disponível nos canais oficiais da GPS Drive.</p>
      </>
    ),
  },
  {
    title: "14. Contato",
    body: (
      <p>
        Caso tenha dúvidas sobre esta Política de Privacidade, sobre o tratamento de dados pessoais ou sobre
        a utilização da plataforma GPS Drive, disponibilizaremos canais oficiais de atendimento para essas
        solicitações.
      </p>
    ),
  },
];

const LAST_UPDATED = "9 de setembro de 2026";

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4 sm:py-14">
      <div className="mx-auto max-w-3xl rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200 sm:p-10">
        <header className="mb-8 border-b border-slate-200 pb-6">
          <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">Política de Privacidade — GPS Drive</h1>
          <p className="mt-2 text-sm text-slate-500">Última atualização: {LAST_UPDATED}</p>
          <p className="mt-4 text-sm leading-relaxed text-slate-600">
            A GPS Drive valoriza a privacidade e a proteção dos dados pessoais de seus usuários. Esta
            Política de Privacidade explica como os dados são coletados, utilizados, armazenados e
            protegidos durante a utilização da plataforma, do aplicativo e dos serviços GPS Drive.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            Ao utilizar nossos serviços, você declara estar ciente das práticas descritas nesta Política.
          </p>
        </header>

        <div className="space-y-8">
          {SECTIONS.map((section) => (
            <section key={section.title}>
              <h2 className="mb-2 text-lg font-semibold text-slate-900">{section.title}</h2>
              <div className="space-y-2 text-sm leading-relaxed text-slate-600">{section.body}</div>
            </section>
          ))}
        </div>

        <footer className="mt-10 border-t border-slate-200 pt-6 text-sm text-slate-500">
          <p className="font-semibold text-slate-700">GPS Drive</p>
          <p>Tecnologia para monitoramento e gestão de veículos.</p>
        </footer>
      </div>
    </div>
  );
}
